import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { authorized, getUserBalanceList } from "_src/servers/v1/users";

import {
  isAppSupportedNetworkId,
  isAppSupportedChainId,
} from "_src/utils/chain";

export const setTheme = createAction("global/setTheme");

export const setIsSupportNetworkAction = createAction(
  "global/setIsSupportNetworkAction"
);

export const setNetworkIdAction = createAction(
  "global/setNetworkId",
  (networkId) => {
    if (isAppSupportedNetworkId(networkId)) {
      return { payload: networkId };
    } else {
      return { payload: "" };
    }
  }
);

export const setChainIdAction = createAction("global/setChainId", (chainId) => {
  if (isAppSupportedChainId(chainId)) {
    return { payload: chainId };
  } else {
    return { payload: "" };
  }
});

export const loginAsync = createAsyncThunk(
  "global/fetchUserData",
  async (_, { getState }) => {
    const {
      global: { address = "", networkId = "" },
    } = getState();
    const [userResponse, balanceResponse] = await Promise.all([
      authorized({ address }),
      getUserBalanceList({
        address,
        chain_id: networkId,
      }),
    ]);

    const useData = userResponse?.data || {};
    const balanceList = balanceResponse?.data || [];

    return { useData, balanceList };
  }
);

export const getBalanceList = createAsyncThunk(
  "global/getBalanceList",
  async (_, { getState }) => {
    const {
      global: { address = "", networkId = "" },
    } = getState();

    const res = await getUserBalanceList({
      address,
      chain_id: networkId,
    });

    if (res && res.code === 1000) {
      return res?.data || {};
    }

    return {};
  }
);
